const getFormattedOrderTime = time => time?.toFormat('hh:mma')?.toLowerCase();

export const getFormatttedOrderingTimeSlot = ({ startTime, endTime }) =>
  `${getFormattedOrderTime(startTime)} - ${getFormattedOrderTime(endTime)}`;
